import { flatten } from 'components/TreeSelect';
import { dateToFormat } from 'helpers/formatters/date';
import {
  CompositeWeightedLineItem,
  CompositeWeightedTimeWindow,
} from 'types/CompositeWeighted';
import { TagRefDefinitionDataProps } from 'types/TagRefDefinition';
import { Api } from '../../../api';
import { formatToDate } from 'helpers/date';

export type RowType = {
  fromDate: string;
  selectionSet: string;
  property: string;
  propertyValue: string;
};

export const getRowFormatted = (row: any) => {
  return {
    tabName: row.fromDate,
    data: {
      fromDate: row.fromDate,
      selectionSet: row.assetSelectionSet,
      property: row.tagRefPropertyDefinition,
      propertyValue: row.propertyValue,
      isTimeWindowEnable: true,
    },
  };
};

export const useTable = (
  data: Array<CompositeWeightedTimeWindow>,
  onDeleteRow?: (fromDate: string) => void
) => {
  const { data: assets } = Api.lookup.GetAssetSelectionSets();
  const { data: tagRef } = Api.lookup.GetTagRefPropertyDefinitions();

  const columns = [
    {
      Header: 'From Date',
      accessor: 'fromDate',
    },
    {
      Header: 'To Date',
      accessor: 'toDate',
    },
    {
      Header: 'Selection Set',
      accessor: 'assetSelectionSet',
    },
    {
      Header: 'Property',
      accessor: 'tagRefPropertyDefinition',
    },
    {
      Header: 'Property Value',
      accessor: 'propertyValue',
      Cell: (row: any) => (
        <div style={{ whiteSpace: 'pre-line' }}>{row.value}</div>
      ),
    },
  ];

  const actionDeleteRow = (onCloseModal: any, row: any) => {
    onDeleteRow?.(row[0].fromDate);
    onCloseModal();
  };

  function getPropertyValueLabel(timeWindow: CompositeWeightedTimeWindow) {
    const tags = timeWindow.lineItems.map(
      (lineItem: CompositeWeightedLineItem) => lineItem.weightingComponentTagId
    );
    if (tags) {
      const flattenedProps = flatten(
        tagRef?.find((tag) => timeWindow.tagRefPropertyDefinitionId === tag.id)
          ?.tags ?? []
      );
      return (
        flattenedProps
          ?.filter((tag: TagRefDefinitionDataProps) => tags.includes(tag.id))
          ?.map((tag: TagRefDefinitionDataProps) => tag.name)
          ?.join('\n') ?? '-'
      );
    }
    return '-';
  }
  return {
    data: data
      ? data?.map((item) => ({
          ...item,
          fromDate: dateToFormat(new Date(item.fromDate), 'MM/dd/y'),
          toDate: formatToDate(item.fromDate, item.toDate),
          assetSelectionSet:
            assets?.find((asset) => +asset.value === +item.assetSelectionSetId)
              ?.label || '-',
          tagRefPropertyDefinition:
            tagRef?.find(
              (tag: any) => +tag.id === +item.tagRefPropertyDefinitionId
            )?.name || '-',
          propertyValue: getPropertyValueLabel(item),
        }))
      : [],
    columns,
    actionDeleteRow,
  };
};
